function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "currentColor",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12.2 17.5v2a1.2 1.2 0 01-1.2 1.2H4a1.2 1.2 0 01-1.2-1.2v-15A1.2 1.2 0 014 3.3h7a1.2 1.2 0 011.2 1.2v2a.8.8 0 101.6 0v-2A2.8 2.8 0 0011 1.7H4a2.8 2.8 0 00-2.8 2.8v15A2.8 2.8 0 004 22.3h7a2.8 2.8 0 002.8-2.8v-2a.8.8 0 10-1.6 0z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.38 7.234l4.429 4.429a.8.8 0 010 1.131l-4.429 4.43a.8.8 0 01-1.131-1.132l3.076-3.078H9.8a.8.8 0 01-.794-.7l-.006-.1a.8.8 0 01.8-.8h11.497l-3.048-3.048a.8.8 0 011.131-1.132z"
}));

var SvgMute = function SvgMute(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMute, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/mute.ca866b46.svg";
export { ForwardRef as ReactComponent };